import {createStorageManager} from '@sollapay/utils';
import {useState} from 'react';

export type Theme = 'light' | 'dark';

const storage = createStorageManager({prefix: 'sollapay'});

function isTheme(value: unknown): value is Theme {
  return value === 'light' || value === 'dark';
}

export function useThemePreference(storageKey = 'theme', defaultTheme: Theme = 'light') {
  const [theme, setTheme] = useState<Theme>(() => {
    const stored = storage.getItem(storageKey);
    return stored !== null && isTheme(stored) ? stored : defaultTheme;
  });

  return {
    theme,
    setPreferredTheme: (next: Theme) => {
      setTheme(next);
      storage.setItem(storageKey, next);
    }
  };
}
